export default __webpack_public_path__ + "static/media/chart_data.d1d086a2.svg";